export default __webpack_public_path__ + "static/media/eye.f4ba8cc4.svg";